<template>
  <div id="installVideo">
    <div class="videoContent">
      <div class="titleContainer">
        <div class="titleVideo">
          <img class="img" :src="`${uploadUrl}${$route.query.productImg}`" alt="">
        </div>
        <div class="title">
          <div class="top">{{$route.query.productName}}</div>
          <div class="bottom">{{$route.query.videoTitle}}</div>
        </div>
      </div>
      <video class="checkVideo" :src="`${uploadUrl}${$route.query.id}`" controls="controls"></video>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "installVideo",
  data() {
    return {
      uploadUrl: ""
    };
  },
  created() {},
  mounted() {
    this.uploadUrl = apis.uploadUrl;
  },
  methods: {
  
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #installVideo {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #installVideo {
    width: 276px * $zoom;
  }
}
#installVideo {
  font-size: 16px * $zoom;
  height: 1470px;
  background-color: #000000;
  .videoContent {
    // width: 679px;
    width: 100%;
    height: 100%;
    position: relative;
    .titleContainer{
      position: absolute;
      align-items: center;
      top: 32px;
      left: 40px;
      display: flex;
      .titleVideo{
        margin-right: 20px;
        .img{
          width: 92px;
          height: 92px;
          border-radius: 50%;
        }
      }
      .title{
        color: #FFFFFF;
        .top{
          font-size: 33px;
          line-height: 50px;
          font-weight: 400;
        }
        .bottom{
          font-size: 23px;
          line-height: 36px;
        }
      }
    }
    .checkVideo {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
